import { useMutation } from '@tanstack/react-query';
import { sendPush, subscribePush, unsubscribePush } from './push.api';
export const useSubscribePushMutation = () => {
    return useMutation({
        mutationFn: subscribePush
    });
};
export const useUnsubscribePushMutation = () => {
    return useMutation({
        mutationFn: unsubscribePush
    });
};
export const useSendPushMutation = () => {
    return useMutation({
        mutationFn: sendPush
    });
};
//# sourceMappingURL=push.query.js.map